import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import { register as registerSwiperElements } from 'swiper/element/bundle';
import { environment } from './environment/environment';
if (environment.production) {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}
registerSwiperElements(); // <-- register Swiper elements

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
